module.exports = __webpack_public_path__ + "img/region_norte.216dc850.svg";